import React from 'react';
import TeamSlider from '../../components/slider/TeamSlider';

const Team = () => {

    return (
        <>
          {/*Team One Start*/}
          <section className="team-one">
                <div className="container">
                <div className="team-one__top">
                    <div className="text-left section-title">
                    <div className="section-title__tagline-box">
                        <span className="section-title__tagline">Our Team</span>
                    </div>
                    <h2 className="border-b-4 section-title__title border-b-orange-900">
                    Meet the Visionaries Behind the Lens 
                    </h2>
                    </div>
                    <div className="team-one__nav">
                    <div className="swiper-button-next1">
                        <i className="icon-arrow-left" />
                    </div>
                    <div className="swiper-button-prev1">
                        <i className="icon-arrow-right" />
                    </div>
                    </div>
                </div>
                <div className="team-one__bottom">
                    
                    <TeamSlider/>

                </div>
                </div>
            </section>
            {/*Team One End*/}  
        </>
    );
}

export default Team;
